import React from "react";
import useToggle from "../../../../Hooks/useToggle";
// import Search from "../../../Search";
import MainHeader from "./MainHeader";
// import TopHeader from "./TopHeader";
import { useEffect, useRef, useState } from "react";
import Navigation from "../../../Helpers/Navigation";
import logo from '../../../../assets/images/News/uk-express.png'

const HeaderOne = ({ drawerAction }) => {
  const [show, setValue] = useToggle(false);

  const stickyRef = useRef(null);
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => {
        setStuck(!e.isIntersecting);
      },
      { threshold: 0.1, rootMargin: "0px 0px 0px 0px" }
    );
    if (stickyRef.current) {
      observer.observe(stickyRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return (
    <>
    <div class="head-out"
    style={{
      overflow: "auto",
      overflowX: "hidden",
      flex: 1,
      position: "relative",
    }}
    >
      {/* <Search
        className={`${show ? "open" : ""}`}
        searchAction={setValue.toggle}
      /> */}
      {stuck && (
        <div class="head-in">
          <div class="logo-tab">
            <a href="/">
          <img width={180} height={80} src={logo} alt="" /></a>
          <div className="binduz-er-navbar-btn d-flex">
                    <span
                      onClick={drawerAction}
                      className="binduz-er-toggle-btn binduz-er-news-canvas_open d-block d-lg-none"
                    >
                      <i className="fal fa-bars"></i>
                    </span>
                  </div>
            </div>
            <div className="head-float">
          <Navigation/>
          </div>
        </div>
      )}
      {/* <TopHeader /> */}
      <MainHeader searchAction={setValue.toggle} drawerAction={drawerAction} stickyRef={stickyRef}/>
      </div>
    </>
  );
};

export default HeaderOne;
